import Icon from "@3gaam/shared/components/general/icon";
import { useRatingComponent } from "../useRatingComponent";

type Props = {
  rate: number | undefined;
  onClick: (value: number) => void;
};
export const StarRating = ({ rate, onClick }: Props) => {
  let { Rating } = useRatingComponent();
  return (
    <div className="d-flex flex-row align-items-center">
      <Rating
        fillColor="#f9c12c"
        transition
        ratingValue={0}
        onClick={onClick}
        tooltipStyle={{ display: "none" }}
        rtl={true}
        allowHalfIcon={true}
        fullIcon={<Icon name="FA_S-star" className={`${"font-24 mx-1"}`} />}
        emptyIcon={
          <Icon
            name="FA_S-star"
            className={`${"font-24 mx-1"}`}
            style={{ color: "#e9e9e9" }}
          />
        }
      />
    </div>
  );
};
